module.exports = __webpack_public_path__ + "img/24.85fe326e.svg";